import React from 'react';
import themes from '@digitools/honest-react/dist/lib/theming/themes';
import { GrayTextDiv, GraySpacerDiv } from 'src/components/Formatting/StyledComponents';
import { Col, Icon } from '@digitools/honest-react';
import styled from 'styled-components';
import { ReviewText } from '../../constants/ReviewText';
import useTranslate from 'src/hooks/useTranslate';
const StyledButton = styled('button') `
  outline: none;
  border: none;
  font-size: 1rem;
  background: inherit;
  color: #23669a;
  flex: 1;
  text-align: right;

  &:hover {
    cursor: pointer;
  }
`;
export const EditReviewField = ({ onClick, ...rest }) => {
    const { t } = useTranslate();
    return (<StyledButton onClick={onClick} {...rest}>
      <Icon color="secondary" className="mr-2" name="edit"/>
      {t(ReviewText.editButton)}
    </StyledButton>);
};
const ReviewField = ({ label, value, small = false, ...rest }) => {
    return (<GrayTextDiv {...rest}>

        {value != null && value != '' ? (<div>
                {label}
                <div style={{ color: `${themes.rebrand.palette.grayDark}`, fontWeight: 300, fontSize: small ? '1rem' : '1.125rem', minHeight: value == '' ? '.4rem' : undefined }}>
                    {value}
                </div>
            </div>) : (<div style={{ paddingBottom: '.4375rem' }}>
              <Col>
                {label}
              </Col>
              <Col>
                <span className={'sr-only'}>Undefined</span>
              </Col>
          </div>)}
      <GraySpacerDiv style={{ marginTop: value ? undefined : small ? '1.2rem' : '1.3rem' }}/>
      
    </GrayTextDiv>);
};
export default ReviewField;
//TODO: Export into honest as a new field
// DisplayField  FieldDisplay -- some more generic name
